import React from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import * as api from "../../../../apis/platforms/admin/warehouseVoucher";
import useAntTable from "../../../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import {Button, Space} from "antd";
import dayjs from "dayjs";


function WarehouseVoucher() {

    const {tableProps, download, downloading, search, form} = useAntTable(api.getVoucher, {
        method: 'POST',
        downloadUrl: api.exportVoucher,
    })

    const columns: StandardColumnsType = [
        {
            title: "入库单号",
            dataIndex: "no",
            search: true
        },
        {
            title: "入库日期",
            dataIndex: "date",
            render: (value) => dayjs(value).format("lll"),
            search: {
                valueType: 'dateRange'
            }
        },
        {
            title: "客户名称",
            dataIndex: "dealerName",
            search: true
        },
        {
            title: "行号",
            dataIndex: "lineNumber",
        },
        {
            title: "物料编码",
            dataIndex: "productNo",
            search: true
        },
        {
            title: "物料名称",
            dataIndex: "productName",
            search: true
        },
        {
            title: "实收数量",
            dataIndex: "qty",
        },
        {
            title: "订单号",
            dataIndex: "orderNo",
            search: true
        },
        {
            title: "订单行号",
            dataIndex: "orderLineNumber",
        },
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} search={search} form={form} {...tableProps} toolbar={(
                <Space>
                    <Button type={'primary'}>同步入库凭证</Button>
                    <Button type={'primary'} loading={downloading} onClick={() => download()}>导出</Button>
                </Space>
            )}/>
        </PageHeaderLayout>
    )
}

export default WarehouseVoucher;
